/**
 * useTokenDetail — Fetches comprehensive token detail (metadata + stats).
 *
 * Story 4.1: Token Detail API hooks
 */

import { useQuery } from "@tanstack/react-query";
import { tokensApi } from "../../lib/api";
import { tokenKeys } from "./query-keys";

export function useTokenDetail(id: string) {
	return useQuery({
		queryKey: tokenKeys.detail(id),
		queryFn: async () => {
			const response = await tokensApi.getDetail(id);
			return response.data;
		},
		enabled: !!id,
		staleTime: 15_000,
	});
}
